import { IKoumuten, IKoumutenType } from '../../../types/record/koumuten';
import {
  IKoumutenAPIValidationErrorFactory,
  IKoumutenAPIValidationErrorType,
  KoumutenAPIRawSuccessResponseType,
  KoumutenAPIRawValidationErrorType
} from '../../types/koumuten/api-response';
import { nullableToStringList } from '../nullable-to-string-list';

export const IKoumutenFromAPISuccessResponse = ({
  id,
  name,
  company_count,
  author,
  can_be_deleted,
  created_at,
  updated_at
}: KoumutenAPIRawSuccessResponseType): IKoumutenType =>
  IKoumuten({
    id,
    name,
    numCompanies: company_count,
    author,
    canBeDeleted: can_be_deleted,
    dateCreated: new Date(created_at).getTime(),
    dateUpdated: new Date(updated_at).getTime()
  });

export const IKoumutenAPIValidationError = ({
  name
}: KoumutenAPIRawValidationErrorType): IKoumutenAPIValidationErrorType =>
  IKoumutenAPIValidationErrorFactory({
    name: nullableToStringList(name)
  });
